import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {KfConfigurationSearch} from '../../../../kf-reporting/models/kf-configuration-search.interface';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-kf-configuration-filter',
  templateUrl: './kf-configuration-filter.component.html',
  styleUrls: ['./kf-configuration-filter.component.scss']
})
export class KfConfigurationFilterComponent implements OnInit {


  searchForm = this.formBuilder.group({
    startYear: [''],
    endYear: [''],
    unuKey: [''],
    kfCategory: [''],
    collectionStream: [''],
    isLaunch: [],
    startLaunched: [''],
    endLaunched: [''],
    open: []
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }
  get endYearControl(): FormControl {
    return this.searchForm.get('endYear') as FormControl;
  }
  get unuKeyControl(): FormControl {
    return this.searchForm.get('unuKey') as FormControl;
  }
  get kfCategoryControl(): FormControl {
    return this.searchForm.get('kfCategory') as FormControl;
  }
  get collectionStreamControl(): FormControl {
    return this.searchForm.get('collectionStream') as FormControl;
  }
  get isLaunchControl(): FormControl {
    return this.searchForm.get('isLaunch') as FormControl;
  }
  get startLaunchedControl(): FormControl {
    return this.searchForm.get('startLaunched') as FormControl;
  }
  get endLaunchedControl(): FormControl {
    return this.searchForm.get('endLaunched') as FormControl;
  }

  get openControl(): FormControl {
    return this.searchForm.get('open') as FormControl;
  }

  @Output()
  search: EventEmitter<KfConfigurationSearch> = new EventEmitter<KfConfigurationSearch>();

  constructor(private formBuilder: FormBuilder,
              private datePipe: DatePipe,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.setFormValuesFromQueryParams();
  }

  handleSubmit(): void {
    const search: KfConfigurationSearch = {
      startYear: this.startYearControl.value,
      endYear: this.endYearControl.value,
      unuKeyName: this.unuKeyControl.value,
      kfCategoryName: this.kfCategoryControl.value,
      collectionStreamName: this.collectionStreamControl.value,
      launched: this.isLaunchControl.value,
      startLaunched: this.datePipe.transform(this.startLaunchedControl.value, 'dd-MM-yyyy'),
      endLaunched: this.datePipe.transform(this.endLaunchedControl.value, 'dd-MM-yyyy'),
      open: this.openControl.value,
    };
    this.search.emit(search);
  }

  clean(): void {
    this.search.emit({});
  }

  private setFormValuesFromQueryParams(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        this.searchForm.get('startYear')?.setValue(params.startYear);
      }
      if (params.endYear) {
        this.searchForm.get('endYear')?.setValue(params.endYear);
      }
      if (params.unuKeyName) {
        this.searchForm.get('unuKey')?.setValue(params.unuKeyName);
      }
      if (params.kfCategoryName) {
        this.searchForm.get('kfCategory')?.setValue(params.kfCategoryName);
      }
      if (params.collectionStreamName) {
        this.searchForm.get('collectionStream')?.setValue(params.collectionStreamName);
      }
      if (params.launched !== undefined) {
        this.searchForm.get('isLaunch')?.setValue(params.launched);
      }
      if (params.startLaunched) {
        this.searchForm.get('startLaunched')?.setValue(new Date(params.startLaunched));
      }
      if (params.endLaunched) {
        this.searchForm.get('endLaunched')?.setValue(new Date(params.endLaunched));
      }

    });
  }

}
